module.exports = __webpack_public_path__ + "static/media/digital-bc-icon-177x197.b21ebeb5.jpg";